import { Head, Link, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Activity {
  id: number
  title: string
}
interface Option {
  id: number
  name: string
}
interface Props {
  activity: Activity
  customers: Option[]
  errors?: Record<string, string[]>
}

export default function New({ activity, customers, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Activities", href: "/marketing_activities" },
    { title: activity.title, href: `/marketing_activities/${activity.id}` },
    {
      title: "Attendees",
      href: `/marketing_activities/${activity.id}/list_items`,
    },
    {
      title: "Add",
      href: `/marketing_activities/${activity.id}/list_items/new`,
    },
  ]
  const { data, setData, post, processing, transform } = useForm({
    customer_id: "",
  })

  transform((data) => ({ marketing_activity_list_item: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/marketing_activities/${activity.id}/list_items`)
  }
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Add Customer to List" />
      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">
          Add Customer to {activity.title}
        </h1>
        <form onSubmit={handleSubmit} className="max-w-xl space-y-4">
          <div>
            <label className="block font-medium">Customer</label>
            <select
              value={data.customer_id}
              onChange={(e) => setData("customer_id", e.target.value)}
              className="w-full rounded border px-3 py-2"
            >
              <option value="">Select...</option>
              {customers.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
            {errors?.customer_id && (
              <p className="text-hpi-red text-sm">
                {errors.customer_id.join(", ")}
              </p>
            )}
          </div>
          <div className="flex gap-4">
            <button
              type="submit"
              disabled={processing}
              className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white disabled:opacity-50"
            >
              Add
            </button>
            <Link
              href={`/marketing_activities/${activity.id}/list_items`}
              className="hover:bg-hpi-pale-gray rounded border px-4 py-2"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </AppLayout>
  )
}
